var cov_1khs4i46cy = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Scroll/Bar.tsx",
      hash = "88ecf43c43fdd4d12bb15d91b1e4f091232397ca",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Scroll/Bar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 16
        }
      },
      "1": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "2": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 48
        }
      },
      "3": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 56
        }
      },
      "4": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 54
        }
      },
      "5": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 58
        }
      },
      "6": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "7": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 22
        }
      },
      "8": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "9": {
        start: {
          line: 45,
          column: 28
        },
        end: {
          line: 45,
          column: 76
        }
      },
      "10": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      "11": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 50
        }
      },
      "12": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 20
        }
      },
      "13": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 64
        }
      },
      "14": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 58
        }
      },
      "15": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 38
        }
      },
      "16": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "17": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 67
        }
      },
      "18": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 61
        }
      },
      "19": {
        start: {
          line: 69,
          column: 23
        },
        end: {
          line: 69,
          column: 33
        }
      },
      "20": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 29
        }
      },
      "21": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 37
        }
      },
      "22": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 31
        }
      },
      "23": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 31
        }
      },
      "24": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 31
        }
      },
      "25": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 20
        }
      },
      "26": {
        start: {
          line: 79,
          column: 14
        },
        end: {
          line: 79,
          column: 41
        }
      },
      "27": {
        start: {
          line: 80,
          column: 14
        },
        end: {
          line: 80,
          column: 41
        }
      },
      "28": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 31
        }
      },
      "29": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 31
        }
      },
      "30": {
        start: {
          line: 84,
          column: 55
        },
        end: {
          line: 84,
          column: 65
        }
      },
      "31": {
        start: {
          line: 85,
          column: 18
        },
        end: {
          line: 85,
          column: 43
        }
      },
      "32": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "33": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 65
        }
      },
      "34": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 65
        }
      },
      "35": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 36
        }
      },
      "36": {
        start: {
          line: 93,
          column: 23
        },
        end: {
          line: 93,
          column: 36
        }
      },
      "37": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 36
        }
      },
      "38": {
        start: {
          line: 94,
          column: 23
        },
        end: {
          line: 94,
          column: 36
        }
      },
      "39": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 46
        }
      },
      "40": {
        start: {
          line: 95,
          column: 40
        },
        end: {
          line: 95,
          column: 46
        }
      },
      "41": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 32
        }
      },
      "42": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 23
        }
      },
      "43": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 44
        }
      },
      "44": {
        start: {
          line: 101,
          column: 38
        },
        end: {
          line: 101,
          column: 44
        }
      },
      "45": {
        start: {
          line: 103,
          column: 66
        },
        end: {
          line: 103,
          column: 76
        }
      },
      "46": {
        start: {
          line: 104,
          column: 17
        },
        end: {
          line: 104,
          column: 52
        }
      },
      "47": {
        start: {
          line: 106,
          column: 20
        },
        end: {
          line: 106,
          column: 26
        }
      },
      "48": {
        start: {
          line: 107,
          column: 17
        },
        end: {
          line: 107,
          column: 49
        }
      },
      "49": {
        start: {
          line: 108,
          column: 17
        },
        end: {
          line: 108,
          column: 80
        }
      },
      "50": {
        start: {
          line: 109,
          column: 16
        },
        end: {
          line: 109,
          column: 79
        }
      },
      "51": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "52": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 31
        }
      },
      "53": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 38
        }
      },
      "54": {
        start: {
          line: 112,
          column: 25
        },
        end: {
          line: 112,
          column: 38
        }
      },
      "55": {
        start: {
          line: 113,
          column: 11
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "56": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 31
        }
      },
      "57": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 38
        }
      },
      "58": {
        start: {
          line: 115,
          column: 25
        },
        end: {
          line: 115,
          column: 38
        }
      },
      "59": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 23
        }
      },
      "60": {
        start: {
          line: 122,
          column: 80
        },
        end: {
          line: 122,
          column: 90
        }
      },
      "61": {
        start: {
          line: 123,
          column: 25
        },
        end: {
          line: 123,
          column: 35
        }
      },
      "62": {
        start: {
          line: 124,
          column: 17
        },
        end: {
          line: 124,
          column: 38
        }
      },
      "63": {
        start: {
          line: 125,
          column: 16
        },
        end: {
          line: 125,
          column: 23
        }
      },
      "64": {
        start: {
          line: 126,
          column: 22
        },
        end: {
          line: 129,
          column: 5
        }
      },
      "65": {
        start: {
          line: 131,
          column: 18
        },
        end: {
          line: 131,
          column: 47
        }
      },
      "66": {
        start: {
          line: 132,
          column: 14
        },
        end: {
          line: 132,
          column: 36
        }
      },
      "67": {
        start: {
          line: 133,
          column: 33
        },
        end: {
          line: 133,
          column: 35
        }
      },
      "68": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "69": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 141,
          column: 7
        }
      },
      "70": {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 57
        }
      },
      "71": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 137,
          column: 24
        }
      },
      "72": {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 139,
          column: 58
        }
      },
      "73": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 25
        }
      },
      "74": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 25
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 39
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        loc: {
          start: {
            line: 43,
            column: 44
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 43
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 33
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 52
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 16
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 61
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 58
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 68
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 37
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 78
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 57
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 100
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 11
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 121
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }],
        line: 44
      },
      "1": {
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 44,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 44,
            column: 19
          }
        }, {
          start: {
            line: 44,
            column: 23
          },
          end: {
            line: 44,
            column: 45
          }
        }, {
          start: {
            line: 44,
            column: 49
          },
          end: {
            line: 44,
            column: 82
          }
        }],
        line: 44
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 85,
            column: 18
          },
          end: {
            line: 85,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 38
          },
          end: {
            line: 85,
            column: 39
          }
        }, {
          start: {
            line: 85,
            column: 42
          },
          end: {
            line: 85,
            column: 43
          }
        }],
        line: 85
      },
      "4": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }],
        line: 87
      },
      "5": {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 25
          }
        }, {
          start: {
            line: 87,
            column: 29
          },
          end: {
            line: 87,
            column: 36
          }
        }],
        line: 87
      },
      "6": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 36
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 36
          }
        }],
        line: 93
      },
      "7": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 36
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 36
          }
        }],
        line: 94
      },
      "8": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 46
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 46
          }
        }],
        line: 95
      },
      "9": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 44
          }
        }, {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 44
          }
        }],
        line: 101
      },
      "10": {
        loc: {
          start: {
            line: 108,
            column: 17
          },
          end: {
            line: 108,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 108,
            column: 27
          },
          end: {
            line: 108,
            column: 52
          }
        }, {
          start: {
            line: 108,
            column: 55
          },
          end: {
            line: 108,
            column: 80
          }
        }],
        line: 108
      },
      "11": {
        loc: {
          start: {
            line: 109,
            column: 16
          },
          end: {
            line: 109,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 109,
            column: 26
          },
          end: {
            line: 109,
            column: 51
          }
        }, {
          start: {
            line: 109,
            column: 54
          },
          end: {
            line: 109,
            column: 79
          }
        }],
        line: 109
      },
      "12": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }],
        line: 110
      },
      "13": {
        loc: {
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 110,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 9
          },
          end: {
            line: 110,
            column: 26
          }
        }, {
          start: {
            line: 110,
            column: 30
          },
          end: {
            line: 110,
            column: 33
          }
        }, {
          start: {
            line: 110,
            column: 39
          },
          end: {
            line: 110,
            column: 56
          }
        }, {
          start: {
            line: 110,
            column: 60
          },
          end: {
            line: 110,
            column: 84
          }
        }],
        line: 110
      },
      "14": {
        loc: {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 112,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 112,
            column: 38
          }
        }, {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 112,
            column: 38
          }
        }],
        line: 112
      },
      "15": {
        loc: {
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 116,
            column: 5
          }
        }],
        line: 113
      },
      "16": {
        loc: {
          start: {
            line: 113,
            column: 15
          },
          end: {
            line: 113,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 16
          },
          end: {
            line: 113,
            column: 33
          }
        }, {
          start: {
            line: 113,
            column: 37
          },
          end: {
            line: 113,
            column: 41
          }
        }, {
          start: {
            line: 113,
            column: 47
          },
          end: {
            line: 113,
            column: 64
          }
        }, {
          start: {
            line: 113,
            column: 68
          },
          end: {
            line: 113,
            column: 92
          }
        }],
        line: 113
      },
      "17": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 38
          }
        }, {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 38
          }
        }],
        line: 115
      },
      "18": {
        loc: {
          start: {
            line: 127,
            column: 36
          },
          end: {
            line: 127,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 36
          },
          end: {
            line: 127,
            column: 40
          }
        }, {
          start: {
            line: 127,
            column: 44
          },
          end: {
            line: 127,
            column: 50
          }
        }],
        line: 127
      },
      "19": {
        loc: {
          start: {
            line: 127,
            column: 52
          },
          end: {
            line: 127,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 52
          },
          end: {
            line: 127,
            column: 60
          }
        }, {
          start: {
            line: 127,
            column: 64
          },
          end: {
            line: 127,
            column: 74
          }
        }],
        line: 127
      },
      "20": {
        loc: {
          start: {
            line: 127,
            column: 76
          },
          end: {
            line: 127,
            column: 103
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 76
          },
          end: {
            line: 127,
            column: 88
          }
        }, {
          start: {
            line: 127,
            column: 92
          },
          end: {
            line: 127,
            column: 103
          }
        }],
        line: 127
      },
      "21": {
        loc: {
          start: {
            line: 132,
            column: 14
          },
          end: {
            line: 132,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 20
          },
          end: {
            line: 132,
            column: 27
          }
        }, {
          start: {
            line: 132,
            column: 30
          },
          end: {
            line: 132,
            column: 36
          }
        }],
        line: 132
      },
      "22": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }],
        line: 134
      },
      "23": {
        loc: {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }, {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }],
        line: 135
      },
      "24": {
        loc: {
          start: {
            line: 145,
            column: 78
          },
          end: {
            line: 145,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 85
          },
          end: {
            line: 145,
            column: 103
          }
        }, {
          start: {
            line: 145,
            column: 106
          },
          end: {
            line: 145,
            column: 115
          }
        }],
        line: 145
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Scroll/Bar.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { scrollClass } from './styles';
import fixedLength from './fixedLength';
import { isRTL } from '../config';

var ScrollBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ScrollBar, _PureComponent);

  var _super = _createSuper2(ScrollBar);

  function ScrollBar(props) {
    var _this;

    _classCallCheck(this, ScrollBar);

    cov_1khs4i46cy.f[0]++;
    cov_1khs4i46cy.s[0]++;
    _this = _super.call(this, props);
    _this.handle = void 0;
    _this.cacheOffset = void 0;
    _this.mouseX = void 0;
    _this.mouseY = void 0;
    cov_1khs4i46cy.s[1]++;
    _this.state = {
      dragging: false
    };
    cov_1khs4i46cy.s[2]++;
    _this.bindHandle = _this.bindHandle.bind(_assertThisInitialized(_this));
    cov_1khs4i46cy.s[3]++;
    _this.handleBarClick = _this.handleBarClick.bind(_assertThisInitialized(_this));
    cov_1khs4i46cy.s[4]++;
    _this.handleBgClick = _this.handleBgClick.bind(_assertThisInitialized(_this));
    cov_1khs4i46cy.s[5]++;
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    cov_1khs4i46cy.s[6]++;
    _this.unbindEvent = _this.unbindEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScrollBar, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1khs4i46cy.f[1]++;
      cov_1khs4i46cy.s[7]++;
      this.unbindEvent();
    }
  }, {
    key: "toggleClassList",
    value: function toggleClassList(method) {
      cov_1khs4i46cy.f[2]++;
      cov_1khs4i46cy.s[8]++;

      if ((cov_1khs4i46cy.b[1][0]++, this.handle) && (cov_1khs4i46cy.b[1][1]++, this.handle.parentNode) && (cov_1khs4i46cy.b[1][2]++, this.handle.parentNode.parentNode)) {
        cov_1khs4i46cy.b[0][0]++;

        var _ref = (cov_1khs4i46cy.s[9]++, this.handle.parentNode.parentNode),
            classList = _ref.classList;

        cov_1khs4i46cy.s[10]++;

        if (classList) {
          cov_1khs4i46cy.b[2][0]++;
          cov_1khs4i46cy.s[11]++;
          classList[method](scrollClass('dragging'));
        } else {
          cov_1khs4i46cy.b[2][1]++;
        }
      } else {
        cov_1khs4i46cy.b[0][1]++;
      }
    }
  }, {
    key: "bindHandle",
    value: function bindHandle(el) {
      cov_1khs4i46cy.f[3]++;
      cov_1khs4i46cy.s[12]++;
      this.handle = el;
    }
  }, {
    key: "bindEvent",
    value: function bindEvent() {
      cov_1khs4i46cy.f[4]++;
      cov_1khs4i46cy.s[13]++;
      document.addEventListener('mousemove', this.handleMouseMove);
      cov_1khs4i46cy.s[14]++;
      document.addEventListener('mouseup', this.unbindEvent);
    }
  }, {
    key: "unbindEvent",
    value: function unbindEvent() {
      cov_1khs4i46cy.f[5]++;
      cov_1khs4i46cy.s[15]++;
      this.setState({
        dragging: false
      });
      cov_1khs4i46cy.s[16]++;
      this.toggleClassList('remove');
      cov_1khs4i46cy.s[17]++;
      document.removeEventListener('mousemove', this.handleMouseMove);
      cov_1khs4i46cy.s[18]++;
      document.removeEventListener('mouseup', this.unbindEvent);
    }
  }, {
    key: "handleBarClick",
    value: function handleBarClick(event) {
      cov_1khs4i46cy.f[6]++;

      var _ref2 = (cov_1khs4i46cy.s[19]++, this.props),
          offset = _ref2.offset;

      cov_1khs4i46cy.s[20]++;
      this.cacheOffset = offset;
      cov_1khs4i46cy.s[21]++;
      this.setState({
        dragging: true
      });
      cov_1khs4i46cy.s[22]++;
      this.mouseX = event.clientX;
      cov_1khs4i46cy.s[23]++;
      this.mouseY = event.clientY;
      cov_1khs4i46cy.s[24]++;
      this.toggleClassList('add');
      cov_1khs4i46cy.s[25]++;
      this.bindEvent();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      cov_1khs4i46cy.f[7]++;
      var x = (cov_1khs4i46cy.s[26]++, event.clientX - this.mouseX);
      var y = (cov_1khs4i46cy.s[27]++, event.clientY - this.mouseY);
      cov_1khs4i46cy.s[28]++;
      this.mouseX = event.clientX;
      cov_1khs4i46cy.s[29]++;
      this.mouseY = event.clientY;

      var _ref3 = (cov_1khs4i46cy.s[30]++, this.props),
          direction = _ref3.direction,
          length = _ref3.length,
          onScroll = _ref3.onScroll,
          barLength = _ref3.barLength;

      var value = (cov_1khs4i46cy.s[31]++, direction === 'x' ? (cov_1khs4i46cy.b[3][0]++, x) : (cov_1khs4i46cy.b[3][1]++, y));
      var newOffset;
      cov_1khs4i46cy.s[32]++;

      if ((cov_1khs4i46cy.b[5][0]++, direction === 'x') && (cov_1khs4i46cy.b[5][1]++, isRTL())) {
        cov_1khs4i46cy.b[4][0]++;
        cov_1khs4i46cy.s[33]++;
        newOffset = this.cacheOffset - value / (length - barLength);
      } else {
        cov_1khs4i46cy.b[4][1]++;
        cov_1khs4i46cy.s[34]++;
        newOffset = this.cacheOffset + value / (length - barLength);
      }

      cov_1khs4i46cy.s[35]++;

      if (newOffset < 0) {
        cov_1khs4i46cy.b[6][0]++;
        cov_1khs4i46cy.s[36]++;
        newOffset = 0;
      } else {
        cov_1khs4i46cy.b[6][1]++;
      }

      cov_1khs4i46cy.s[37]++;

      if (newOffset > 1) {
        cov_1khs4i46cy.b[7][0]++;
        cov_1khs4i46cy.s[38]++;
        newOffset = 1;
      } else {
        cov_1khs4i46cy.b[7][1]++;
      }

      cov_1khs4i46cy.s[39]++;

      if (newOffset === this.cacheOffset) {
        cov_1khs4i46cy.b[8][0]++;
        cov_1khs4i46cy.s[40]++;
        return;
      } else {
        cov_1khs4i46cy.b[8][1]++;
      }

      cov_1khs4i46cy.s[41]++;
      this.cacheOffset = newOffset;
      cov_1khs4i46cy.s[42]++;
      onScroll(newOffset);
    }
  }, {
    key: "handleBgClick",
    value: function handleBgClick(event) {
      cov_1khs4i46cy.f[8]++;
      cov_1khs4i46cy.s[43]++;

      if (event.target === this.handle) {
        cov_1khs4i46cy.b[9][0]++;
        cov_1khs4i46cy.s[44]++;
        return;
      } else {
        cov_1khs4i46cy.b[9][1]++;
      }

      var _ref4 = (cov_1khs4i46cy.s[45]++, this.props),
          direction = _ref4.direction,
          length = _ref4.length,
          scrollLength = _ref4.scrollLength,
          offset = _ref4.offset,
          onScroll = _ref4.onScroll;

      var rect = (cov_1khs4i46cy.s[46]++, this.handle.getBoundingClientRect());
      var newOffset = (cov_1khs4i46cy.s[47]++, offset);
      var page = (cov_1khs4i46cy.s[48]++, length / (scrollLength - length));
      var plus = (cov_1khs4i46cy.s[49]++, isRTL() ? (cov_1khs4i46cy.b[10][0]++, event.clientX < rect.left) : (cov_1khs4i46cy.b[10][1]++, event.clientX > rect.left));
      var add = (cov_1khs4i46cy.s[50]++, isRTL() ? (cov_1khs4i46cy.b[11][0]++, event.clientX > rect.left) : (cov_1khs4i46cy.b[11][1]++, event.clientX < rect.left));
      cov_1khs4i46cy.s[51]++;

      if ((cov_1khs4i46cy.b[13][0]++, direction === 'x') && (cov_1khs4i46cy.b[13][1]++, add) || (cov_1khs4i46cy.b[13][2]++, direction === 'y') && (cov_1khs4i46cy.b[13][3]++, event.clientY < rect.top)) {
        cov_1khs4i46cy.b[12][0]++;
        cov_1khs4i46cy.s[52]++;
        newOffset = offset - page;
        cov_1khs4i46cy.s[53]++;

        if (newOffset < 0) {
          cov_1khs4i46cy.b[14][0]++;
          cov_1khs4i46cy.s[54]++;
          newOffset = 0;
        } else {
          cov_1khs4i46cy.b[14][1]++;
        }
      } else {
        cov_1khs4i46cy.b[12][1]++;
        cov_1khs4i46cy.s[55]++;

        if ((cov_1khs4i46cy.b[16][0]++, direction === 'x') && (cov_1khs4i46cy.b[16][1]++, plus) || (cov_1khs4i46cy.b[16][2]++, direction === 'y') && (cov_1khs4i46cy.b[16][3]++, event.clientY > rect.top)) {
          cov_1khs4i46cy.b[15][0]++;
          cov_1khs4i46cy.s[56]++;
          newOffset = offset + page;
          cov_1khs4i46cy.s[57]++;

          if (newOffset > 1) {
            cov_1khs4i46cy.b[17][0]++;
            cov_1khs4i46cy.s[58]++;
            newOffset = 1;
          } else {
            cov_1khs4i46cy.b[17][1]++;
          }
        } else {
          cov_1khs4i46cy.b[15][1]++;
        }
      }

      cov_1khs4i46cy.s[59]++;
      onScroll(newOffset);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1khs4i46cy.f[9]++;

      var _ref5 = (cov_1khs4i46cy.s[60]++, this.props),
          direction = _ref5.direction,
          length = _ref5.length,
          scrollLength = _ref5.scrollLength,
          offset = _ref5.offset,
          barLength = _ref5.barLength,
          forceHeight = _ref5.forceHeight;

      var _ref6 = (cov_1khs4i46cy.s[61]++, this.state),
          dragging = _ref6.dragging;

      var show = (cov_1khs4i46cy.s[62]++, scrollLength > length);
      var rtl = (cov_1khs4i46cy.s[63]++, isRTL());
      var className = (cov_1khs4i46cy.s[64]++, classnames(scrollClass('bar', direction, (cov_1khs4i46cy.b[18][0]++, show) && (cov_1khs4i46cy.b[18][1]++, 'show'), (cov_1khs4i46cy.b[19][0]++, dragging) && (cov_1khs4i46cy.b[19][1]++, 'dragging'), (cov_1khs4i46cy.b[20][0]++, !forceHeight) && (cov_1khs4i46cy.b[20][1]++, 'padding-y')), this.props.className));
      var value = (cov_1khs4i46cy.s[65]++, (length - barLength) * offset);
      var x = (cov_1khs4i46cy.s[66]++, rtl ? (cov_1khs4i46cy.b[21][0]++, 'right') : (cov_1khs4i46cy.b[21][1]++, 'left'));
      var style = (cov_1khs4i46cy.s[67]++, {});
      cov_1khs4i46cy.s[68]++;

      if (scrollLength > 0) {
        cov_1khs4i46cy.b[22][0]++;
        cov_1khs4i46cy.s[69]++;

        if (direction === 'x') {
          cov_1khs4i46cy.b[23][0]++;
          cov_1khs4i46cy.s[70]++;
          style.width = "".concat(length / scrollLength * 100, "%");
          cov_1khs4i46cy.s[71]++;
          style[x] = value;
        } else {
          cov_1khs4i46cy.b[23][1]++;
          cov_1khs4i46cy.s[72]++;
          style.height = "".concat(length / scrollLength * 100, "%");
          cov_1khs4i46cy.s[73]++;
          style.top = value;
        }
      } else {
        cov_1khs4i46cy.b[22][1]++;
      }

      cov_1khs4i46cy.s[74]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: {
            height: forceHeight
          },
          onMouseDown: show ? (cov_1khs4i46cy.b[24][0]++, this.handleBgClick) : (cov_1khs4i46cy.b[24][1]++, undefined),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 145,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: scrollClass('handle'),
          onMouseDown: this.handleBarClick,
          ref: this.bindHandle,
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 146,
            columnNumber: 9
          }
        }))
      );
    }
  }]);

  return ScrollBar;
}(PureComponent);

ScrollBar.defaultProps = {
  direction: 'y'
};
export default fixedLength(ScrollBar);